import * as T from '../types';

/** The agenda with `updated` in place of the occurrence it was: same place in its day, or moved to its new day. */
export function replaceOccurrence(agenda: T.TaskAgenda, updated: T.TaskOccurrence): T.TaskAgenda {
  const overdue = updated.isOverdue && updated.status === 'Pending';
  const others = (list: T.TaskOccurrence[]) => list.filter(o => o.publicId !== updated.publicId);
  const into = (list: T.TaskOccurrence[]) => {
    const at = list.findIndex(o => o.publicId === updated.publicId);
    if (at >= 0 && list[at].date === updated.date) return list.map((o, i) => (i === at ? updated : o));
    // Stable sort by day: the others keep their order
    return others(list).concat(updated)
      .map((o, i) => ({ o, i }))
      .sort((a, b) => (a.o.date < b.o.date ? -1 : a.o.date > b.o.date ? 1 : a.i - b.i))
      .map(x => x.o);
  };
  return overdue
    ? { ...agenda, overdue: into(agenda.overdue), occurrences: others(agenda.occurrences) }
    : { ...agenda, overdue: others(agenda.overdue), occurrences: into(agenda.occurrences) };
}
